import { useMemo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CellCreatedOn, CellFolderName, CellFolderTags, CellOwner } from '../Cells';

export default function useFoldersTableColumns() {
  const isDesktop = useMediaQuery('(min-width:900px)');

  return useMemo(() => [
    {
      accessor: 'name',
      id: 'name',
      Header: 'Name',
      Cell: CellFolderName,
      minWidth: 305,
    },
    isDesktop ? {
      accessor: 'tags',
      id: 'tags',
      Header: 'Tags',
      Cell: CellFolderTags,
      minWidth: 175,
      maxWidth: 0,
    } : null,
    isDesktop ? {
      accessor: 'owner',
      id: 'owner',
      Header: 'Owner',
      Cell: CellOwner,
      width: 80,
    } : undefined,
    isDesktop ? {
      accessor: 'createdOn',
      id: 'createdOn',
      Header: 'Created On',
      Cell: CellCreatedOn,
      minWidth: 80,
      width: 80,
    } : undefined,
  ].filter(Boolean), [isDesktop]);
}

export { useFoldersTableColumns };